module.exports = __webpack_public_path__ + "static/media/WorcesterLogo.17c64290.png";